import { render, staticRenderFns } from "./Workshop_tutong.vue?vue&type=template&id=16d578d3&"
import script from "./Workshop_tutong.vue?vue&type=script&lang=js&"
export * from "./Workshop_tutong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports